// Libs
import { TreeItems } from 'dnd-kit-sortable-tree';
// Others
import { ITreeItem } from '~/utils/interface/common';
import { IProductGroup } from '~/utils/interface/quotes';

export const handleFindParentByIdTree = (
  items: TreeItems<ITreeItem<IProductGroup>>,
  targetId: string
): ITreeItem<IProductGroup> | null => {
  for (const item of items) {
    if (item.children?.some((child) => child.id === targetId)) {
      return item;
    }

    if (item.children?.length) {
      const parent = handleFindParentByIdTree(item.children, targetId);
      if (parent) return parent;
    }
  }
  return null;
};
